import styled from 'styled-components'
import { TOPBAR_HEIGHT } from '@/v2/constants'
import Typography from '@/v2/components/common/Typography'

export const Wrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.primary.main};
  height: ${TOPBAR_HEIGHT};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  overflow-x: auto;
  flex-shrink: 0;

  @media (max-width: 1024px) {
    padding: 0 10px;
    gap: 8px;
  }
`

export const NavigationWrapper = styled.div`
  display: flex;
  column-gap: 7px;
  justify-content: center;
  align-items: center;
`

export const DateWrapper = styled(Typography)`
  && {
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 4px;
    white-space: nowrap;

    @media (max-width: 1024px) {
      font-size: 14px;
      margin-left: 4px;
      margin-right: 4px;
    }
  }
`

export const FilterWrapper = styled.div`
  display: flex;
  column-gap: 20px;
  align-items: center;
  justify-content: center;

  && > button,
  && > a {
    width: 134px;
    text-transform: capitalize;
  }

  @media (max-width: 1366px) {
    column-gap: 12px;

    && > button,
    && > a {
      width: 100px;
      font-size: 13px;
    }
  }
`

export const Filters = styled.div`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 7px;
  }

  @media (max-width: 1366px) {
    && {
      column-gap: 4px;
    }
  }
`

export const ButtonsWrapper = styled.div`
  display: flex;
  column-gap: 7px;

  && > button,
  && > a {
    width: 134px;
    text-transform: uppercase;
  }

  @media (max-width: 1366px) {
    column-gap: 4px;

    && > button,
    && > a {
      width: 80px;
      font-size: 12px;
      padding: 6px 8px;
    }
  }
`

export const MobileFilterWrapper = styled.div`
  display: flex;
  column-gap: 8px;
  align-items: center;
`

export const MobileButtonsWrapper = styled.div`
  display: flex;
  column-gap: 4px;

  && > button,
  && > a {
    min-width: 60px;
    padding: 4px 8px;
    font-size: 12px;
    text-transform: uppercase;
  }
`

// Mobile Calendar Header Styles
export const MobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${({ theme }) => theme.primary.main};
  background: #fff;
`

export const MobileHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
`

export const MobileDateSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;

  svg {
    font-size: 20px;
    color: #666;
  }
`

export const MobileDateText = styled(Typography)`
  && {
    font-size: 18px;
    font-weight: 600;
  }
`

export const MobileTodayButton = styled.button.attrs({ type: 'button' })`
  background: none;
  border: none;
  color: #2196f3;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  z-index: 1;

  &:hover {
    opacity: 0.8;
  }
`

export const MobileWeekStrip = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 8px 16px 12px;
`

export const MobileWeekDay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`

export const MobileWeekDayLabel = styled.span`
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
`

export const MobileWeekDayNumber = styled.span`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: ${({ $isSelected }) => ($isSelected ? '600' : '400')};
  color: ${({ $isSelected, $isToday }) =>
    $isSelected ? '#fff' : $isToday ? '#2196f3' : '#333'};
  background: ${({ $isSelected }) => ($isSelected ? '#333' : 'transparent')};
  border-radius: 8px;
  border-bottom: ${({ $hasEvents }) =>
    $hasEvents ? '2px solid #f5a623' : 'none'};
`

export const MobileFiltersRow = styled.div`
  display: flex;
  gap: 12px;
  padding: 0 16px 12px;

  & > * {
    flex: 1;
    min-width: 0;
  }
`
